import * as yup from 'yup'

export const orderAuditArchivedNoteModalSchema = yup.object().shape({
  note: yup.string().required('Note is required'),
})
